import Table from '@mui/material/Table';
export default Table;
